import store from "../store";
import connect_api from "../connect/connect_api";
import notification from "../components/subcomponents/notification";

function get_config(callback) {
  connect_api.sPOST("/config/get_config", {}, function (error, response) {
    if (error) {
      //notification.error(error.message);
      console.log(error);
      callback(error, false);
    } else {
      store.dispatch({
        type: "CONFIG_DETAILS",
        data: response.api_data,
      });
      callback(false, response.api_data);
    }
  });
}

function get_log_info(callback) {
  connect_api.sPOST("/config/get_log_info", {}, function (error, response) {
    if (error) {
      console.log(error);
      callback(error, false);
    } else {
      callback(false, response);
    }
  });
}

function get_log_error(callback) {
  connect_api.sPOST("/config/get_log_error", {}, function (error, response) {
    if (error) {
      console.log(error);
      callback(error, false);
    } else {
      callback(false, response);
    }
  });
}

function update(param, callback) {
  const error_validation_action_type = "CONFIG_VALIDATION_ERROR";
  const error_update_action_type = "CONFIG_UPDATED_ERROR";

  connect_api.sPOST("/config/update", param, function (error, response) {
    if (!error) {
      store.dispatch({
        type: "CONFIG_DETAILS",
        data: response.api_data,
      });
      callback(false, response.api_data);
    } else {
      if (error.api_error.type === "VALIDATION_ERROR") {
        store.dispatch({
          type: error_validation_action_type,
          data: error.api_error.fields,
        });
        callback("Validation error", false);
      } else {
        store.dispatch({
          type: error_update_action_type,
        });
        callback(error.message, response);
      }
    }
  });
}

function update_all(callback) {
  const state = store.getState();
  const error_validation_action_type = "CONFIG_VALIDATION_ERROR";
  const error_update_action_type = "CONFIG_UPDATED_ERROR";

  connect_api.sPOST(
    "/config/update",
    state.systemR.config_db,
    function (error, response) {
      if (!error) {
        store.dispatch({
          type: "CONFIG_DETAILS",
          data: response.api_data,
        });
        callback(false, response.api_data);
      } else {
        console.log(error);
        notification.error(error.message);
        if (error.api_error.type === "VALIDATION_ERROR") {
          store.dispatch({
            type: error_validation_action_type,
            data: error.api_error.fields,
          });
          callback("Validation error", false);
        } else {
          store.dispatch({
            type: error_update_action_type,
          });
          callback(error, response);
        }
      }
    }
  );
}

export default {
  get_config: get_config,
  update_all: update_all,
  update: update,
  get_log_info: get_log_info,
  get_log_error: get_log_error,
};
